import { useQuery } from '@tanstack/react-query';

import { getMe } from '~modules/user/api/service/lessor-user';

type UseGetUserOptions = {
  enabled?: boolean;
  silentAuthFailure?: boolean;
};

export const useGetUser = (options: UseGetUserOptions = {}) => {
  return useQuery({
    queryKey: ['user'],
    queryFn: () =>
      getMe({ silentAuthFailure: options.silentAuthFailure ?? false }),
    meta: {
      skipGlobalErrorToast: true,
    },
    retry: false,
    enabled: options.enabled ?? true,
  });
};
